import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en/translation.json";
import ko from "./ko/translation.json";
import { convertLanguageJsonToObject } from "./translations";

export const translationsJson = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

// 저장된 언어 설정 가져오기 (localStorage 우선, 없으면 쿠키 확인)
const getSavedLanguage = () => {
  const localStorageLng = localStorage.getItem('i18nextLng');
  if (localStorageLng) return localStorageLng;
  
  // 쿠키에서 언어 설정 찾기
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('i18nextLng=')) {
      return cookie.substring('i18nextLng='.length, cookie.length);
    }
  }
  
  return null;
};

// 언어 감지기 설정
const languageDetector = new LanguageDetector();
languageDetector.init({
  // 언어 감지 순서
  order: ['localStorage', 'cookie', 'querystring', 'navigator'],
  // 쿼리 파라미터 이름
  lookupQuerystring: 'lng',
  // localStorage 키 이름
  lookupLocalStorage: 'i18nextLng',
  // 쿠키 키 이름
  lookupCookie: 'i18nextLng',
  // 언어 설정 캐시
  caches: ['localStorage', 'cookie'],
  // 쿠키 옵션
  cookieOptions: {
    path: '/',
    sameSite: 'strict',
    secure: true,
    expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
  }
});

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: http://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  // init i18next
  // for all options read: http://www.i18next.com/overview/configuration-options
  .init({
    resources: translationsJson,
    fallbackLng: "ko",
    defaultNS: "translation",
    lng: getSavedLanguage() || "ko", // 저장된 언어 설정 사용, 없으면 한국어
    debug:
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function(value, format, lng) {
        // 소문자로 변환하여 번역 키 대소문자 구분 제거
        if (format === 'lowercase') return value.toLowerCase();
        return value;
      }
    },
  });
